import { ScriptDef, ScriptTheme } from '../../types';

export const TV_DUSHI_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_031',
        name: '合租许可证',
        genre: 'tv',
        synopsis: '三个性格迥异的都市女性因一套老洋房的租约纠纷被迫成为室友。前财经记者苏晚宁被裁员后试图转型自媒体，却屡屡碰壁；急诊科医生许知遥事业风生水起，却在职业倦怠与情感空窗中反复拉扯；全职妈妈邹月带着女儿净身出户，在合租生活中重新找回被婚姻磨掉的自我。三人从互相嫌弃到彼此托底，在烟火气十足的合租日常中，各自找到了生活的“许可证”。',
        roles: [
            {
                name: '苏晚宁',
                roleType: '女主角',
                billing: 2,
                intro: '前财经记者，30岁被裁后转型自媒体博主。嘴上毒舌犀利，骨子里是个害怕失败的完美主义者。在流量焦虑与新闻理想的拉扯中，逐渐学会了“不体面地活着也没关系”。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '许知遥',
                roleType: '女主角',
                billing: 2,
                intro: '三甲医院急诊科主治医师。外表冷静理性，内心却极度渴望被爱。因长期扮演“好医生”角色而压抑自我，在与比自己小五岁的实习医生的相处中，第一次卸下防备，学会了“被照顾”和“为自己而活”。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2 },
            },
            {
                name: '邹月',
                roleType: '女主角',
                billing: 2,
                intro: '全职妈妈，为家庭放弃法学学位。离婚后带女儿住进合租房，从唯唯诺诺的“某某妈妈”重新变回有名字的自己，最终通过法考重启人生。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Female, ScriptTheme.Urban, ScriptTheme.LifeStyle],
        heat: 54,
        baseScore: 6.8,
    },
    {
        id: 'SCRIPT_032',
        name: '她的房间',
        genre: 'tv',
        synopsis: '一栋即将拆迁的老公寓里，四位女性因各自的理由拒绝搬离。独居作家陈漫在截稿日与拆迁通知的双重夹击下陷入创作危机；退休教师周敏华守着亡夫的遗物不肯放手；95后外卖骑手小葵把这里当成在大城市唯一的落脚点；海归建筑师林之遥则因一纸遗嘱意外获得了整栋楼的产权。四个女人在“拆”与“留”的拉锯中，各自直面了不愿触碰的过往。',
        roles: [
            {
                name: '陈漫',
                roleType: '女主角',
                billing: 2,
                intro: '悬疑小说作家，独居三年，靠咖啡和deadline续命。她的小说总在写别人的秘密，却从未敢面对自己的。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '小葵',
                roleType: '女主角',
                billing: 2,
                intro: '小镇来沪的外卖骑手，白天送餐晚上自考大专。她是整栋楼里最沉默的人，也是最清醒的人。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 30 },
                    { attr: 'stamina', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, stamina: 2 },
            },
            {
                name: '林之遥',
                roleType: '女主角',
                billing: 2,
                intro: '海归建筑师，冷感疏离，因继承遗产被迫回到这栋楼。她以为自己是局外人，最终发现自己才是那个最需要被“拆”的人。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'charm', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, charm: 2 },
            },
            {
                name: '小马',
                roleType: '男配角',
                billing: 5,
                intro: '拆迁办测绘员，图上量过这栋楼一百次，头一回走进来。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Female, ScriptTheme.Urban, ScriptTheme.LifeStyle],
        heat: 60,
        baseScore: 7.6,
    },
    {
        id: 'SCRIPT_033',
        name: '三餐四季',
        genre: 'tv',
        synopsis: '前大厂运营林豆豆被优化后，盘下了巷口那家快要转让的社区食堂。手腕旧伤退下灶台的西餐主厨瞿见山、离婚的全职妈妈翁小萍先后入伙，三个人凑钱把店开起来，取名“三餐四季”。三个被生活打断的人，在这间小小的食堂里，一餐一餐地找回了自己的节奏。',
        roles: [
            {
                name: '林豆豆',
                roleType: '女主角',
                billing: 1,
                intro: '前大厂运营总监，靠 Excel 和倒排期表统筹项目的“人形规划器”。被优化后盘下这家社区食堂，从零学起掌勺，做菜的手艺还停在“西红柿炒蛋都炒糊”的阶段。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2 },
            },
            {
                name: '瞿见山',
                roleType: '男主角',
                billing: 1,
                intro: '星级酒店西餐主厨，因手腕旧伤退下一线灶台。为人要强嘴硬，见不得采购单写错半个字，退居后厨后仍事事亲力亲为。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '翁小萍',
                roleType: '女二号',
                billing: 2,
                intro: '离婚的全职妈妈，八年婚姻里只落得一个“小孩她妈”的称呼。做得一手女儿爱吃的家常菜，靠这手艺应聘进店，从帮厨做起。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 2, temperament: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Female, ScriptTheme.Urban, ScriptTheme.LifeStyle],
        heat: 56,
        baseScore: 7.1,
    },
    {
        id: 'SCRIPT_034',
        name: '晚风过境',
        genre: 'tv',
        synopsis: '危机公关总监宋知微，擅长替客户收拾烂摊子，却把自己的感情生活处理得一塌糊涂。一次品牌舆情危机里，她要压下的那篇稿子，出自深度报道记者陆砚辞之手。一个守信源，一个守甲方，两人从交锋时的互不留情，到为同一份底稿不得不并肩核对，谁也没想到，最先守不住的是各自那点体面。',
        roles: [
            {
                name: '宋知微',
                roleType: '女主角',
                billing: 1,
                intro: '上海一家公关公司的危机公关总监，凌晨处理客户突发舆情是家常便饭，甲方施压和团队管理两头扛。她替客户撤过上百条热搜，轮到自己被拍进热搜那晚，她关了手机。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '陆砚辞',
                roleType: '男主角',
                billing: 1,
                intro: '深度报道记者，跑了十二年社会线，信源比人脉多。他认定公关都是给真相化妆的人，直到撞见宋知微在凌晨的办公室里，压下了一份不实的声明稿没发。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2 },
            },
            {
                name: '周也宁',
                roleType: '女二号',
                billing: 2,
                intro: '纪录片导演，宋知微大学时期的旧友。性格自由散漫、嘴硬心软，习惯用镜头记录他人的故事，却在面对自身感情时屡屡失焦。经历一段失败恋情后，逐渐学会直面内心真实需求。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 2, temperament: 2, charm: 2 },
            },
            {
                name: '程屹',
                roleType: '男二号',
                billing: 2,
                intro: '品牌创始人，宋知微长期服务的甲方。成熟、危险、懂得如何让人心动，他的出现让陆砚辞第一次意识到体面的人也会吃醋，成为推动男女主关系转变的关键变量。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 2, talent: 2, charm: 2 },
            },
            {
                name: '费可',
                roleType: '女配角',
                billing: 5,
                intro: '律所前台，替宋知微挡过的客户比她办过的案子还多。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 1,
                attributeGrowth: { temperament: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.Romance, ScriptTheme.LifeStyle],
        heat: 58,
        baseScore: 7.2,
    },
    {
        id: 'SCRIPT_035',
        name: '离岸三十海里',
        genre: 'tv',
        synopsis: '海事法院法官江听澜常年审跨境航运纠纷的案子，冷静锋利，从不把私人情绪带进判决书。直到她在一桩货轮事故案中，遇见了航运公司风控负责人沈既白。两人从厘清责任到并肩调查，在案件、港口和雨夜中逐渐靠近，最终学会承认自己需要对方。',
        roles: [
            {
                name: '江听澜',
                roleType: '女主角',
                billing: 1,
                intro: '海事法院法官，常年审跨境航运纠纷的案子。法庭上寸步不让，生活里却常常忘记吃饭。她不是冷，只是习惯了用专业挡住所有不确定。在货轮事故案中与沈既白从对立走向并肩，逐渐学会承认自己需要对方。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '沈既白',
                roleType: '男主角',
                billing: 1,
                intro: '航运公司风控负责人，具有沉默克制、责任感极强的人物特质。他像一座离岸很远的灯塔，不主动靠近，却始终为江听澜留一盏灯。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '阮听潮',
                roleType: '女二号',
                billing: 2,
                intro: '港口记者，性格敏锐、执拗、相信真相。她的调查线推动了案件反转，也让男女主不得不面对各自的隐瞒，成为推动主线剧情的关键人物。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'wisdom', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 2, wisdom: 2, temperament: 2 },
            },
            {
                name: '顾闻舟',
                roleType: '男二号',
                billing: 2,
                intro: '船东继承人，风流、聪明、擅长暧昧。他是江听澜过去的一段旧账，也是沈既白无法忽视的变量，在剧情中制造了关键的情感冲突。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'charm', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.Romance, ScriptTheme.LifeStyle],
        heat: 62,
        baseScore: 7.6,
    },
    {
        id: 'SCRIPT_036',
        name: '第十年特刊',
        genre: 'tv',
        synopsis: '城市杂志主编叶清禾为筹备十周年特刊，定下了“实体书店的末路”这一选题。她需要采访的最后一个案例，是当年不告而别的恋人梁叙开的那家独立书店。一个要写出唱衰行业的爆款，一个要守住理想主义的阵地，两人在采访与反采访中，从立场对立到重新审视彼此。当特刊付印，他们才发现，这期关于“结束”的报道，恰恰是两人关于“开始”的补课。',
        roles: [
            {
                name: '叶清禾',
                roleType: '女主角',
                billing: 1,
                intro: '城市杂志主编，体面、自律、情绪稳定，习惯把生活安排得滴水不漏。她最怕的不是失败，而是承认自己仍然在意。在筹备十周年特刊时重逢旧爱梁叙，从试探到和解，完成了一场关于遗憾与重新出发的迟到的补课。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '梁叙',
                roleType: '男主角',
                billing: 1,
                intro: '独立书店主理人，温和疏离、看似随遇而安。他离开过，也回来过，却始终没有真正放下叶清禾。面对叶清禾带着“任务”的采访，他选择用沉默和温和的反击，让她重新看见自己。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '宋予安',
                roleType: '女二号',
                billing: 2,
                intro: '摄影师，叶清禾的同事兼好友。性格自由、浪漫、敢爱敢恨，她的感情线像叶清禾年轻时的倒影，在剧情中形成对照与呼应。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'charm', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, charm: 2 },
            },
            {
                name: '陆见深',
                roleType: '男二号',
                billing: 2,
                intro: '出版社编辑，梁叙的好友。性格理性、克制、擅长旁观，总在关键时刻提醒梁叙：逃避不是体面，是懦弱，成为推动男主直面内心的关键人物。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.Romance, ScriptTheme.LifeStyle],
        heat: 65,
        baseScore: 8.0,
    },
    {
        id: 'SCRIPT_044',
        name: '首付',
        genre: 'tv',
        synopsis: '2015年，临江市房价连涨。何佩与雷万山一家三口挤在老小区两居室，为凑学区房首付，何佩背着丈夫支取了给娘家侄儿留的教育金，雷万山则把父亲术后复查的钱悄悄垫进了首付——两个人各自越过对方的线，谁也没先开口，架吵到预约了离婚，进了冷静期。冷静期最后一天，两人没去民政局，去了售楼处退掉认购书，回来的定金第二天一早被何佩分成了两份。',
        roles: [
            {
                name: '何佩',
                roleType: '女主角',
                billing: 1,
                intro: '公司行政主管，精打细算到买菜分两个菜市场去，坚信“忍一忍就是一套房”。她的记账本记了九年，最后一页第一次记了一笔不算账的账：丈夫垫出去的复查费。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '雷万山',
                roleType: '男主角',
                billing: 2,
                intro: '何佩的丈夫，出租车司机，腰上有旧伤，不抽烟不喝酒，钱都存成定期。他把父亲术后复查的钱垫进了首付，一直没跟何佩说。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'stamina', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, stamina: 2 },
            },
            {
                name: '何玖',
                roleType: '女配角',
                billing: 3,
                intro: '何佩的妹妹，县城中学的代课老师，电话里永远劝姐姐“回来住”，挂了电话又往姐姐卡里转两万。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '齐加林',
                roleType: '男配角',
                billing: 4,
                intro: '售楼处金牌中介，经手过一百多对凑首付的夫妻，见得最多的是签约之后先翻脸的是谁。他劝何佩的话只有一句：大姐，房子是刚需，脸面不是。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.LifeStyle, ScriptTheme.Urban],
        heat: 58,
        baseScore: 7.9,
    },
    {
        id: 'SCRIPT_045',
        name: '42天',
        genre: 'tv',
        synopsis: '尹南音生下女儿后的42天里，家里的门开了又关。挪了半年房贷钱请的月嫂干了九天不辞而别，钱追不回来；婆婆吴凤仙从县城赶来接手，用老规矩带新生儿。尹南音的产假只剩五十七天，丈夫邝立群在两个妈之间传话，传着传着话就变了形。满月酒那天，亲妈蔡金凤拎着一只老母鸡上门，两个妈在厨房一个烧水一个炖汤，谁也不看谁。第四十二天夜里，孩子第一次整觉睡到天亮，尹南音守在床边看了一整夜，天亮去上班，没叫醒任何人。',
        roles: [
            {
                name: '尹南音',
                roleType: '女主角',
                billing: 1,
                intro: '地铁行车调度员，产前一张排班表精确到分钟，产后没睡过一个整觉。她把坐月子每天发生的事记在台历背面。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '邝立群',
                roleType: '男主角',
                billing: 1,
                intro: '装修公司项目经理，白天盯工地，晚上盯两个妈的脸色。他学会了在楼道里坐十分钟再进门，进门前先想好先回哪句话。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '华姐',
                roleType: '女配角',
                billing: 5,
                intro: '月子餐配送员，上楼从不按门铃，敲门三下，等十秒。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.LifeStyle, ScriptTheme.Female],
        heat: 56,
        baseScore: 7.6,
    },
    {
        id: 'SCRIPT_046',
        name: '归零',
        genre: 'tv',
        synopsis: '闻蔚做了十一年全职太太，离婚起诉书是保姆先看到的。前夫官正则的公司上市在即，婚内财产早两年就层层转移，律师给出的资产清单上，闻蔚名下只有一辆分期没还完的车和婚前那间五十平米的小屋。简历空窗期被不断追问，闺蜜龙韧把她安排进自己公司，从前台干起。她白天面试、傍晚接儿子放学，重启人生的狼狈里，官正则那边还不断派人来“致歉”。',
        roles: [
            {
                name: '闻蔚',
                roleType: '女主角',
                billing: 1,
                intro: '前全职太太，大学毕业证压在衣柜最底层，简历空窗期写着“家庭管理”。重返职场后面试全约在下午四点半之前——四点半要去接儿子。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '官正则',
                roleType: '男配角',
                billing: 2,
                intro: '拟上市公司副总裁，离婚理由是“没有共同语言”，婚内财产转移的手笔干净利落。他按月打抚养费，家长会那天永远在出差。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '龙韧',
                roleType: '女二号',
                billing: 2,
                intro: '人力资源公司合伙人，闻蔚的大学室友。她把闻蔚安排进自己公司从前台干起，没说安慰的话，只连夜帮她改好了简历，在闻蔚躲进楼道里哭的时候假装没看见。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Female, ScriptTheme.Urban, ScriptTheme.LifeStyle],
        heat: 55,
        baseScore: 7.0,
    },
    {
        id: 'SCRIPT_047',
        name: '对半分',
        genre: 'tv',
        synopsis: '龚芷和邵秉义的离婚拉锯战打了十四个月，争的不只是孩子，还有一套待拆迁的学区房和一家小公司的股权。龚芷的母亲搬来同住，实际是来盯财产；邵秉义的父亲把祖传的老宅证押给了律师，要为儿子争一口气。两个律师在走廊里相遇都会互相点头，回到屋里各自教当事人录音、转账、留证据。孩子的抚养权最终判给龚芷，学区房的拆迁款判了各半，宣判那天，孩子在幼儿园画了一张全家福，画上房子中间画了一道线。',
        roles: [
            {
                name: '龚芷',
                roleType: '女主角',
                billing: 1,
                intro: '会计事务所项目经理，离婚理由写的是“感情破裂”，起诉状写了七稿。她在法庭上从没红过眼眶，回车里才哭，哭完补妆去接孩子。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '邵秉义',
                roleType: '男主角',
                billing: 1,
                intro: '小公司老板，婚内出轨的证据链有四十七条，他自己数过。他以为钱能解决的事都不是事，直到法官问孩子跟谁睡习惯了。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '宓雪',
                roleType: '女二号',
                billing: 2,
                intro: '龚芷的代理律师，离婚诉讼打了上百场，办公室抽屉里备着纸巾和糖。她给每个当事人同一个忠告：官司可以打，人别搭进去。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'wisdom', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 2, wisdom: 2, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.LifeStyle, ScriptTheme.Urban],
        heat: 46,
        baseScore: 6.4,
    },
    {
        id: 'SCRIPT_048',
        name: '满血复活',
        genre: 'tv',
        synopsis: '全职主妇米糖在结婚纪念日当天发现丈夫乐志恒出轨，净身出户，带着女儿搬进城中村。落魄之际，她随手做的几道家常菜被路过的餐饮集团总裁端木擎尝到，对方当场拍板请她出任集团行政主厨。三个月内米糖从后厨学徒升任品牌总监，开设的连锁餐馆场场排队。乐志恒的公司濒临破产，恰需与米糖的集团合作，签约席上两人重逢。大结局，乐志恒破产清算的法庭外，米糖与端木擎牵手，身后是她名下的第九家分店。',
        roles: [
            {
                name: '米糖',
                roleType: '女主角',
                billing: 1,
                intro: '全职主妇，厨艺天赋异禀，做的红烧肉能让总裁当场落泪。她十年没工作过，入职三个月学会财务报表、供应链管理和股权设计，学习资料是一套总裁书单。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { charm: 3, talent: 3, temperament: 2 },
            },
            {
                name: '端木擎',
                roleType: '男配角',
                billing: 2,
                intro: '餐饮集团总裁，身家百亿，性格温柔，出现时机精准，每次米糖落难他都在场。他的集团横跨餐饮、地产与物流，米糖需要哪行，集团恰好深耕哪行。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 2, temperament: 2, talent: 2 },
            },
            {
                name: '乐志恒',
                roleType: '男配角',
                billing: 2,
                intro: '米糖前夫，出轨、藏钱、冷暴力样样在行，公司在米糖升任总监当月宣告破产。他在法庭外对米糖说出的最后一句话是：你成功了，我认了。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 2, talent: 2, charm: 2 },
            },
            {
                name: '娇娇',
                roleType: '女配角',
                billing: 3,
                intro: '乐志恒的情人，出场三次，卷款一次，留下忏悔长信一封。信里她管米糖叫姐，最后远走他乡，杳无音信。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Romance, ScriptTheme.Urban, ScriptTheme.LifeStyle],
        heat: 47,
        baseScore: 5.5,
    },
    {
        id: 'SCRIPT_104',  // 低分反面教材·电视剧/低分剧
        name: '酒过三巡',
        genre: 'tv',
        synopsis: '大学室友罗见青、秦朗、项北、边若虚，毕业十年，在各自的小圈子里小有名气——律师声名在外，法餐主厨入围世界大奖，私教带红半边娱乐圈，没火的歌手是全世界最纯粹的音乐老师。一场婚宴上的求救电话把四个人重新凑齐，他们立誓体面地过好下半场：给崩掉的婚姻、盘倒的餐厅、解约的代言、被搁置的原创，一个个把体面挣回来。中年危机接踵而至，酒过三巡，四只杯子又碰在一起——敬兄弟，敬这不服输的人生，敬最好的年代里更好的自己。',
        roles: [
            {
                name: '罗见青',
                roleType: '男主角',
                billing: 2,
                intro: '离婚事务所合伙人，执业二十一年，从没缺席过闺女的家长会。大学兄弟婚宴上当夜第一个赶到小馆子。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '秦朗',
                roleType: '男主角',
                billing: 2,
                intro: '法餐主厨，世界大奖三连提名，守着三十个座位的馆子，菜单锁在保险柜里。租约到期那天，他提着刀进了外卖厨房。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '项北',
                roleType: '男主角',
                billing: 2,
                intro: '健身房私教，明星客户的课表比艺人还满，旧伤复发第一个知道的是馆里的冰袋。康复期在社区健身房开了公益课。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 3, stamina: 3, wisdom: 2 },
            },
            {
                name: '边若虚',
                roleType: '男主角',
                billing: 2,
                intro: '没火的独立歌手，少年宫合唱老师，每周日晚带孩子们上公开课，同一首原创唱了十年，自称全世界最幸福的音乐人。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, charm: 3, wisdom: 2 },
            },
            {
                name: '简宁',
                roleType: '女主角',
                billing: 2,
                intro: '保险调查员，罗见青今年的最大客户，一眼拆穿现场做旧的"意外"，她不信命运，只信签字之前的现场勘查。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '大排档店员',
                roleType: '女配角',
                billing: 5,
                intro: '烤串姑娘，夜班守着炭炉从九点站到后半夜，那桌四个人聊的宿舍旧事，她翻着串全记下了。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'stamina', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Urban, ScriptTheme.LifeStyle, ScriptTheme.Romance],
        heat: 18,
        baseScore: 2.3,
    },
];
